import store from '@/state/store';

// import userApi from '../api/userApi'
// const loggedIn = localStorage.getItem('user')

const resolveAccess = async(store, next) => {
    next();
}

export default [{
        path: '/',
        name: 'default',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/dashboards/default'),
    },
    {
        path: '/users',
        name: 'Users',
        meta: {
            authRequired: true,
            resource: 'users',
            action: 'list'
        },
        component: () =>
            import ('./views/users/Index'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/metadata',
        name: 'Metadata',
        meta: {
            authRequired: true,
            resource: 'metadata',
            action: 'list'
        },
        component: () =>
            import ('./views/metadata/Index'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/users/create',
        name: 'CreateUser',
        meta: {
            authRequired: true,
            resource: 'users',
            action: 'create'
        },
        component: () =>
            import ('./views/users/Create'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/users/edit/:id',
        name: 'UpdateUser',
        meta: {
            authRequired: true,
            resource: 'users',
            action: 'update'
        },
        component: () =>
            import ('./views/users/Update'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/tasks/pending',
        name: 'TasksPending',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/tasks/Waiting.vue')
    },
    {
        path: '/tasks/completed',
        name: 'TasksCompleted',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/tasks/Completed.vue')
    },
    {
        path: '/tasks/sent',
        name: 'TasksSent',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/tasks/Sent.vue')
    },
    {
        path: '/users/show/:id',
        name: 'ShowUser',
        meta: {
            authRequired: true,
            resource: 'users',
            action: 'read'
        },
        component: () =>
            import ('./views/users/Show'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/authorization',
        name: 'Authorization',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/users/unauthorized')
    },
    {
        path: '/user/profile',
        name: 'Profile',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/users/profile'),
    },
    {
        path: '/roles/create',
        name: 'CreateRole',
        meta: {
            authRequired: true,
            resource: 'roles',
            action: 'create'
        },
        component: () =>
            import ('./views/roles/Create'),
    },
    {
        path: '/roles',
        name: 'Roles',
        meta: {
            authRequired: true,
            resource: 'roles',
            action: 'list'
        },
        component: () =>
            import ('./views/roles/Index'),
    },
    {
        path: '/roles/edit/:id',
        name: 'UpdateRoles',
        meta: {
            authRequired: true,
            resource: 'roles',
            action: 'update'
        },
        component: () =>
            import ('./views/roles/Update'),
    },
    {
        path: '/notifications',
        name: 'notifications',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/notifications/notification'),
    },
    {
        path: '/notifications/show/:id',
        name: 'Shownotif',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/notifications/Show'),
    },
    {
        path: '/Preview',
        name: 'Preview',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/users/Preview'),
    },
    {
        path: '/documents',
        name: 'FileManager',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/documents/FileManager'),
    },
    {
        path: '/control-panel',
        name: 'ControlPanel',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/documents/ControlPanel'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/access-control/:dir',
        name: 'AccessControl',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/documents/AccessControl'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/user/reset-password',
        name: 'ResetPassword',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/account/change-password'),
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () =>
            import ('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('userAuth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                        (route) => route.push('/login')
                    )
                    // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'default' } : {...routeFrom })
            },
        },
    },
    {
        path: '/document-types/create',
        name: 'CreateDocumentType',
        meta: {
            authRequired: true,
            action: "create",
            resource : "document-types"
        },
        component: () =>
            import ('./views/documentType/Create'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/document-types',
        name: 'DocumentTypes',
        meta: {
            authRequired: true,
            action: "list",
            resource : "document-types"
        },
        component: () =>
            import ('./views/documentType/Index'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/document-types/show/:id',
        name: 'ShowDocumentTypes',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/documentType/Show'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/document-types/edit/:id',
        name: 'EditDocumentType',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/documentType/Update'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/logs',
        name: 'Journal',
        meta: {
            authRequired: true,
            action: "list",
            resource : "logs"
        },
        component: () =>
            import ('./views/activity/Index'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/workflows',
        name: 'Workflows',
        meta: {
            authRequired: true,
            action: "list",
            resource : "processes"
        },
        component: () =>
            import ('./views/workflow/Index.vue'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/workflows/:id',
        name: 'ManageWorkflow',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/workflow/Manage.vue'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/workflows/show/:id',
        name: 'Details',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/workflow/Show.vue'),
        beforeEnter: async function(to, from, next) {
            resolveAccess(store, next)
        }
    },
    {
        path: '/actions',
        name: 'Create',
        meta: {
            authRequired: true,
            action: "list",
            resource : "actions"
        },
        component: () =>
            import ('./views/actions/Create'),
    },
    {
        path: '/groups',
        name: 'Groups',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/groups/Index.vue')
    },
    {
        path: '/groups/show/:id',
        name: 'ShowGroup',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/groups/Show'),
        beforeEnter: (to, from, next) => {
            resolveAccess(store, next)
        }
    },
    {
        path: '/unreachable',
        name: 'DomainNotFound',
        component: () => import('./views/DomainNotFound')
    },
    {
        path: '*',
        name: 'NotFound',
        component: () => import('./views/NotFound')
    }
]